const $inject = ['settingsService'];

const beamerService = function (settingsService) {
  let service = {
    get: get,
    count: 0,
    url: '',
    getCount: getCount,
    setCount: setCount,
    getUrl: getUrl,
    setUrl: setUrl,
  };

  function get() {
    return new Promise((resolve, reject) => {
      settingsService.getAny().then((settings) => {
        const user = settings.UserDetails || null;
        if (!user) return resolve({});
        let data = {
          userId: user.UserId,
        };
        if (beamer_config.sendUserDetails.toLowerCase() === 'true') {
          const nameParts = user.UserName.split(' ');
          const firstName = nameParts[0];
          const lastName = nameParts.slice(1).join(' ');
          data.userFirstName = firstName;
          data.userLastName = lastName;
          data.userEmail = user.UserEmail;
        }
        $.ajax({
          url: beamer_config.apiUrl,
          method: 'GET',
          headers: {
            'Beamer-Api-Key': beamer_config.apiKey,
          },
          data: data,
          success: (response) => {
            resolve(response);
          },
          error: (error) => {
            reject(error);
          },
        });
      });
    });
  }

  function getCount() {
    return service.count;
  }

  function setCount(count) {
    service.count = count;
  }

  function getUrl() {
    return service.url;
  }

  function setUrl(url) {
    service.url = url;
  }

  return service;
};

beamerService.$inject = $inject;

export default beamerService;



// WEBPACK FOOTER //
// ./src/services/beamerService.js